/**
 * HTML → readable plain text for RAG / snippets.
 * Tag-only strippers leave <style> CSS behind (Gmail Outlook markup).
 */

function isMostlyCss(text: string): boolean {
  if (/#outlook\b|\.mj-|\bmso-|@media\s+only\s+screen/i.test(text)) return true;
  const blocks = text.match(/\{[^{}]{8,}\}/g);
  if (!blocks) return false;
  const cssChars = blocks.reduce((n, b) => n + b.length, 0);
  return cssChars / Math.max(text.length, 1) > 0.4;
}

function stripCssRules(text: string): string {
  return text
    .replace(/@[^{]+\{[\s\S]*?\}/g, " ")
    .replace(/[^{}]+\{[^{}]*\}/g, " ")
    .replace(/\/\*[\s\S]*?\*\//g, " ")
    .replace(/^[.\s}{#@;]+/, " ");
}

export function htmlToPlainText(input: string): string {
  if (!input) return "";
  let text = input
    .replace(/<script[\s\S]*?<\/script>/gi, " ")
    .replace(/<style[\s\S]*?<\/style>/gi, " ")
    .replace(/<head[\s\S]*?<\/head>/gi, " ")
    .replace(/<noscript[\s\S]*?<\/noscript>/gi, " ")
    .replace(/<!--[\s\S]*?-->/g, " ")
    .replace(/\/\*[\s\S]*?\*\//g, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/\s+/g, " ")
    .trim();
  if (isMostlyCss(text) || /^\s*[}.#@]/.test(text)) {
    text = stripCssRules(text).replace(/\s+/g, " ").trim();
  }
  return text;
}

/** True when a retrieval snippet is leftover CSS/HTML chrome, not readable content. */
export function snippetLooksLikeNoise(text: string): boolean {
  const t = htmlToPlainText(text);
  if (t.length < 24) return true;
  if (isMostlyCss(t)) return true;
  if (/^\s*[.#@}/]/.test(t)) return true;
  const punct = (t.match(/[{};]/g) || []).length;
  return punct >= 4 && punct / Math.max(t.length, 1) > 0.04;
}
